import React from 'react';
import "../css/styles.css";
import { connect } from "react-redux";
import { setInfo } from '../redux/actionList';
import withRouterCompat from "../objects/CommonUse/with_router_compat";
import LinkCard from '../components/shared-components/link_card';
import { Tooltip } from 'react-tooltip';
import tooltipHomepageText from './Text/tooltip_homepage_text';
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import buildUrl from '../objects/CommonUse/build_URL';
import Config from '../config';
import WaitTimeSpinner from '../components/shared-components/wait_time_spinner';
//import AdminReportModal from '../components/admin/admin-report-modal';
import ConfigFile from '../datasets/config_file';
import Footer from './footer';
import { UsernameContext } from '../objects/Context/username_context';
import CreatePortal from '../components/login-related/create_portal';
import setTempTokenForFetch from '../objects/CommonUse/set_temp_token_for_fetch';
import StartUpDisplay from './startUpDisplay';
import checkIfTestComplete from '../objects/CommonUse/check_if_test_complete';
import getCurrentDateTime from '../objects/CommonUse/get_current_date_time';


// mapStateToProps:  make Redux data available as props
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameExists: state.gameExists,
    gameData: state.gameData,
    accountSettings: state.accountSettings,
    moneyMgmtTestArr: state.moneyMgmtTestArr,
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

 
class HomePage extends React.Component {
    static contextType = UsernameContext;
    constructor(props) {
        super(props);
      
        this.state = {
            configurationAvailable: null,
            smallSize: window.matchMedia(
                "(min-width: 780px) and (max-width: 949px), (min-width: 780px) and (min-height: 1200px) and (max-width: 1199px)"
                ).matches,
            mediumSize: window.matchMedia("(min-width: 950px) and (max-width: 1199px)").matches,
            largeSize: window.matchMedia("(min-width: 1200px)").matches,
            isZoomed: window.matchMedia(
                "(-webkit-min-device-pixel-ratio: 1.3) and (-webkit-max-device-pixel-ratio: 1.9)" ).matches,
            isIPad: window.matchMedia(
                "(-webkit-min-device-pixel-ratio: 2) and (min-width: 768px) and (max-width: 1366px) and (orientation: landscape)"
                ).matches,
            isIPadPortrait: window.matchMedia(
                "(-webkit-min-device-pixel-ratio: 2) and (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)"
                ).matches,
            isPhone: window.matchMedia(
                "(-webkit-min-device-pixel-ratio: 2) and (max-width: 767px)"
                ).matches,
        
            environment: Config.dataURL.currentEnv,
            adminModalOpen: true,
            eventTracker: ConfigFile.general.eventTracker,
            pendingNavigation:  false,
            accountNbr: ""
        };
    }

    setScreenSizeFormat(){
        switch (true){
            case this.state.isIPad:
                this.screenSize = "ipad";
                break;
            case this.state.isZoomed:
                this.screenSize = "zoom";
                break;
            case this.state.largeSize:
                 this.screenSize = "wide";
                 break;
            case this.state.mediumSize:
                this.screenSize = "medium";
                break;
            case this.state.smallSize:
                this.screenSize = "narrow";
                break;
            case this.state.isIPadPortrait:
                this.screenSize = "tooSmall";
                this.startUpMessage = "rotateDevice"
                break;
            case this.state.isPhone:
            default:
                this.screenSize = "tooSmall";
                this.startUpMessage = "tooNarrow"
                break;
        }
        sessionStorage.setItem("GameScreenSize", this.screenSize);
    }

    onNavigate = (path) => {
        if (!path){
            path = "";
        }
        const { navigate, location } = this.props;
        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (!location || (location && location.pathname !== targetPath)) {
            navigate(`/${path}`, { replace: true });
        }
    };

    
    render() {
        this.setScreenSizeFormat();
        const { gameExists } = this.props;
        const { loggedIn } = this.context;
        console.log('game Exists?: ', gameExists,
                " user logged in? ", loggedIn);
        let testRequired = false;
        this.role = sessionStorage.getItem("userRole");
        if (this.role === "player" && loggedIn === true && gameExists !== null){
            testRequired = checkIfTestComplete(this.props.accountSettings,
                    this.props.moneyMgmtTestArr );
        }
        let waitState = false;
        if ((gameExists === null  && loggedIn === true) || this.state.waitState === true ){
            waitState = true;
        }
        console.log("screenSize is: ", this.screenSize);  
        console.log("props selected: ", this.props.selected)
    return <>
        <span className="container m-0 p-0">
                {waitState  ?
                    <div className="text-center">
                        <WaitTimeSpinner/>
                    </div>
                :
                <span className="row w-100 mx-0">
          {/*          {this.role === "admin"  && this.state.adminModalOpen ?
                        <AdminReportModal
                            show={this.state.adminModalOpen}
                            onClose={() => this.closeAdminReportModal()}
                        />
                    :
                        null
                    }
            */}
                    <div className="col-sm-4">
                        <div className="ml-3">
                            <img className="mt-5 ml-3 homepage-img-size" 
                                src={'./assets/sidebar_icon.png'} alt="Site Icon"/>
                        </div>
                        <div className="mx-4 mt-4 homepage-text decorative homepage-text-size">
                        This self-paced experiential game builds essential financial literacy skills, 
                        supporting students at all levels—from basic concepts to advanced topics. Click 
                        the "About" square to learn more.
                        </div>
                    </div>
                    <div className="input-page-base-card col-sm-4">
                        {this.role === "demo"   ?
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={tooltipHomepageText[0]}>
                                <LinkCard name="Game" imgSrc='./assets/bg_startGame.png' 
                                    destination="" 
                                    allowed={loggedIn} upSize={true}
                                    openLoginMenu={() => this.handleProtectedClick()} />
                                    <Tooltip id="my-tooltip" place="top" />
                            </span>
                        :
                            <>
                               
                            {gameExists === true ? 
                                <>
                                {testRequired === true  ?
                                    <LinkCard name="Game" imgSrc='./assets/bg_startGame.png' 
                                    destination="money-mgmt-test"
                                    allowed={loggedIn} upSize={true}
                                    openLoginMenu={() => this.handleProtectedClick()} />
                                :
                                    <LinkCard name="Game" imgSrc='./assets/bg_startGame.png' 
                                        destination="game-board"
                                        allowed={loggedIn} upSize={true}
                                        openLoginMenu={() => this.handleProtectedClick()} />
                                }
                                </>
                            :
                                <LinkCard name="Game" imgSrc='./assets/bg_startGame.png' 
                                    destination="skills-interests"
                                    allowed={loggedIn} upSize={true}
                                    openLoginMenu={() => this.handleProtectedClick()}/>
                            }
                            </>
                        }
                            
                        <LinkCard name="For Parents/Teachers" imgSrc='./assets/bg_forParents.png' 
                            destination="for-parents-main"
                            allowed={loggedIn} upSize={true}
                            openLoginMenu={() => this.handleProtectedClick()}/>
                    
                    </div>
                    <div className="input-page-base-card col-sm-4">
                          {this.role === "demo"   ?
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={tooltipHomepageText[1]}>
                                <LinkCard name="Extra Credit" imgSrc='./assets/bg_extraCredit.png' 
                                    destination="" 
                                    allowed={loggedIn} upSize={true}
                                    openLoginMenu={() => this.handleProtectedClick()}/>
                            </span>
                        :
                            <LinkCard name="Extra Credit" imgSrc='./assets/bg_extraCredit.png' 
                                destination="extra-credit-main" 
                                allowed={loggedIn} upSize={true}
                                openLoginMenu={() => this.handleProtectedClick()}/>
                        }
                        <LinkCard name="About" imgSrc='./assets/bg_about.png' destination="about-general"
                            upSize={true} allowed={true}/>
                    </div>
                    
                    {(this.screenSize === "zoom") &&
                        <Footer 
                            screenSize={"wide"}
                        />
                     }
                    {this.props.selected === "createTeacherPortal" ||
                     this.props.selected === "createParentPortal"  ||
                     this.props.selected === "createStudentPortal" ?
                        <CreatePortal
                            selected={this.props.selected}
                            accountNbr={this.state.accountNbr}
                            registerComplete={(credentials) => this.registerComplete(credentials)}
                            onClose={() => this.closeLoginForm()}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    :
                        null
                    }
                    {this.screenSize === "tooSmall"  ?
                        <StartUpDisplay
                            messageType={this.startUpMessage}
                        />
                        :
                            null
                        }
                </span>
                }

        {/*
                   {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
        */}
            </span>
        </>
    }
    
    componentDidMount(){
        console.log("homepage did mount");
        this.authErrorCount = 0;
        this.gameData = this.props.gameData;
        if (this.gameData._id){
            this.setState({configurationAvailable: true});
        }
          
        // store media query objects — with the same bounded ranges as initial state
        this.mqLarge = window.matchMedia("(min-width: 1200px)");
        this.mqMedium = window.matchMedia("(min-width: 950px) and (max-width: 1199px)");
        this.mqSmall = window.matchMedia("(min-width: 780px) and (max-width: 949px)");

        // store handlers
        this.handlerLarge = (e) => this.setState({ largeSize: e.matches });
        this.handlerMedium = (e) => this.setState({ mediumSize: e.matches });
        this.handlerSmall = (e) => this.setState({ smallSize: e.matches });

        // add listeners
        this.mqLarge.addEventListener('change', this.handlerLarge);
        this.mqMedium.addEventListener('change', this.handlerMedium);
        this.mqSmall.addEventListener('change', this.handlerSmall);
                 
        this.setScreenSizeFormat();

        const persistentLogs = localStorage.getItem("persistentLogs");
   /*    if (persistentLogs){
            // this downloads the logs to a JSON file - access in Downloads and open with notePad
            const data = JSON.parse(persistentLogs);
            const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'localStorage-persistentLog.json';
            a.click();
        }
    */
        if (persistentLogs){
            console.log('persistentLogs found, localStorage removed')
            localStorage.removeItem('persistentLogs');
        }else{
            console.log("persistent log not found")
        }
    /*    const logs = JSON.parse(localStorage.getItem('persistentLogs') || '[]');
              logs.push("HomePage -" +  new Date().toISOString() );
              localStorage.setItem('persistentLogs', JSON.stringify(logs));
    */
      
   
    }
       
    componentWillUnmount(){
        console.log("homepage will unmount");
        console.log("screenSize is: ", this.screenSize);
        const screenSize = sessionStorage.getItem("GameScreenSize");
        if (!screenSize || screenSize !== this.screenSize){
            sessionStorage.setItem("GameScreenSize", this.screenSize);
        }
        if (this.mqLarge) {
            this.mqLarge.removeEventListener('change', this.handlerLarge);
        }
        if (this.mqMedium) {
            this.mqMedium.removeEventListener('change', this.handlerMedium);
        }
        if (this.mqSmall) {
            this.mqSmall.removeEventListener('change', this.handlerSmall);
        }
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    handleProtectedClick = () => {
        //  replace this with call to autoLogin....
        if (!this.context.loggedIn) {
            this.props.openLoginMenu();
       //     localStorage.removeItem("userToken");
       //  to activate the auto logon feature, comment out the 'this.props.openLoginMenu()
       //  line and uncomment all of the following lines up to 'return'.
       //  You can also uncomment the line directly above this (localStoragee.removeItem)
       //  if you want to test and create a new user token each time you fire up the game.
       //     const userToken = localStorage.getItem("userToken");
       //     this.tokenFound = false;
       //     if (userToken){
       //         sessionStorage.setItem('sessionToken', userToken);
       //         this.tokenFound = true;
       //     }
       //     this.checkOrCreateLogin();
            return;
        }
    }

    registerComplete(closeObj){
        this.processRequested = "LoginForm";
        this.setState({loginLoaded: false});
        if (closeObj){
            this.props.openLoginMenu(closeObj);
        }
        this.closeLoginForm();
    }
    
    closeLoginForm(){
        this.onNavigate("");
    }
    
    closeAdminReportModal(){
        this.setState({adminModalOpen: false});
    }
       
    setSessionStorage(){
        sessionStorage.setItem('username', this.loginInfo.username);
        sessionStorage.setItem('userRole', this.loginInfo.role);
        const demoAccount = ConfigFile.general.demoAccount;
        sessionStorage.setItem('userAccountNbr', demoAccount);
        sessionStorage.setItem('defaultUserAccount', demoAccount);
        sessionStorage.setItem("accountType", "autoPlayer");
        this.props.setInfoRedux(this.loginInfo.role, "playerRole");
        if (this.tokenFound === false){
            const dateAndTime = getCurrentDateTime();
            const tokenStorage = 
                {token: this.loginInfo.userToken, dateTime: dateAndTime.dateTime, process: "" };
            sessionStorage.setItem('sessionToken', JSON.stringify(tokenStorage));
            localStorage.setItem("userToken", JSON.stringify(tokenStorage));
        }
     
    }
 
    setGameInfo(value, propertyName = null)
    {
        if (propertyName)
        {
            this.props.setInfoRedux(value, propertyName);
        }else{
            const errorObj={function: "SetGameInfo", subProcess: this.state.subProcess, 
                status: 999, message: "propertyName is undefined", errorObject: value,
                silentAlert: true};
            this.processErrorReturn(errorObj);
        }
    } 

/*
    checkOrCreateLogin(){
        this.setState({waitState: true});
        let urlParm=" ";
        let headers = "";
        if (this.tokenFound === true){
            headers = setHeadersForFetch();
            urlParm = "?tokenType=PermToken"
        }else{
            headers = setTempTokenForFetch();
            urlParm = "?tokenType=TempToken";
        }
        urlParm += "&accountNbr=" + ConfigFile.general.demoAccount;
        const funcName = "loginAuto";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {method:'POST', headers: headers})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.loginInfo = output.body;
                            this.setSessionStorage();
                            this.props.onSuccessfulLogin(this.loginInfo.username, this.loginInfo.role);
                            this.setState({waitState: false});
                        }else{
                            if (statusCode === 250){
                                //  no event tracker found for this player
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                                this.processErrorReturn(errorObj);
                            }
                        }
                    });
                };
            });
    }
*/

    getEventsTracker() {
        this.setState({waitState: true});
        let headers = setHeadersForFetch();
        const funcName = "loadEventTracker";
        const urlParm = "?rqstType=maxEventNbr";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {method:'GET', headers: headers})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            const maxEventNbr = output.body.maxEventNbr;
                            this.setGameInfo(maxEventNbr, "eventTrackerNbr");
                            this.setState({waitState: false});
                        }else{
                            if (statusCode === 250){
                                //  no event tracker found for this player
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                                this.processErrorReturn(errorObj);
                            }
                        }
                    });
                };
            });
    }
        
    processErrorReturn(errorObj){
        this.addRecordToLogfile(errorObj);
        if (!errorObj.silentAlert || errorObj.silentAlert === false){
            alert ("Uh oh!  Something unexpected has occurred " +
                "error has been logged and will be addressed. " +
                "For now click OK, then return to the process " +
                "where you were and try again.");
        }
        this.onNavigate("");
    }

    addRecordToLogfile(errorObj){
        const tokenFound = sessionStorage.getItem("sessionToken");
        let urlParm = "";
        let headers = "";
        if (tokenFound){
            headers = setHeadersForFetch();  
        }else{
            headers = setTempTokenForFetch("DemoId", "demo!");
            urlParm = "?tokenType=TempToken";
        }
        if (errorObj.status === 250){
            errorObj.message = "No record found";
        }
        if (!errorObj.errorObject){
            errorObj.errorObject = {};
        }
        const logFileBody =  {
            mainProcess: "homepage",
            subProcess: "homePage",
            function: errorObj.function,
            status: errorObj.status,
            message: errorObj.message,
            errorObj: errorObj.errorObject
        }
        console.log("logFileBody is: ", logFileBody)
        let funcName = "saveLogFile"; 
        const uri = buildUrl(this.state.environment, funcName, urlParm)
        fetch (uri,  
            {method: 'POST', headers: headers, body: JSON.stringify(logFileBody)}
            )
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            console.log("write to logfile was successful");
                        }else{
                            console.log("Response from save log file not valid!" +
                            " status is: ", output.statusCode,
                            " message is: ", output.body);
                            alert ("Response from save log file not valid!");
                        
                        }
                });
            }
        });
    
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouterCompat(HomePage));